import { render, staticRenderFns } from "./SimsView.vue?vue&type=template&id=362cf104&"
import script from "./SimsView.vue?vue&type=script&lang=js&"
export * from "./SimsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports